import type { MouseEventHandler } from 'react';
import React, { forwardRef } from 'react'
import type { HeaderCellProps } from './types'
import { Link } from '@ztechapps/webui.util'
import { HeaderCell } from './HeaderCell'

export type LinkHeaderCellProps = {
  disabled?: boolean
  onClick?: MouseEventHandler<HTMLAnchorElement>
} & HeaderCellProps

export const LinkHeaderCell = forwardRef<HTMLTableCellElement, LinkHeaderCellProps>(({ children, onClick, disabled, ...rest }, ref) => {
  return (
    <HeaderCell {...rest} ref={ref}>
      <Link onClick={onClick} disabled={disabled} className="py-0 m-0 d-flex justify-content-between">
        {children}
      </Link>
    </HeaderCell>
  )
})
